var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OpenAI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2819 9.8211a5.9847 5.9847 0 0 0-.5153-4.9066 6.0462 6.0462 0 0 0-3.9991-2.8271 6.0277 6.0277 0 0 0-5.1877 1.2256 6.039 6.039 0 0 0-4.6649-2.233 6.0211 6.0211 0 0 0-5.1136 2.8272 5.9983 5.9983 0 0 0-.5154 4.9066 6.039 6.039 0 0 0 3.9992 2.8273 6.012 6.012 0 0 0-.0128.7348 6.0312 6.0312 0 0 0 1.2384 4.4533 6.0346 6.0346 0 0 0 4.6649 2.233 6.0142 6.0142 0 0 0 5.1136-2.8272 5.9918 5.9918 0 0 0 .5154-4.9066 6.0346 6.0346 0 0 0-3.9992-2.8273 6.0142 6.0142 0 0 0 .0128-.7348zM12 11.2354l-1.9213-1.1093V7.9102l1.9213-1.1093 1.9213 1.1093v2.2159L12 11.2354zm-2.6107.4124l-1.9213 1.1092-1.9213-1.1092V9.4319l1.9213-1.1092 1.9213 1.1092v2.2159zm0-4.4442L7.468 6.0944 9.3893 4.9852l1.9214 1.1092v2.2159l-1.9214-1.1092zM12 4.1018l-1.9213 1.1093-1.9213-1.1093 1.9213-1.1093L12 4.1018zm2.6107.4124l1.9213 1.1092-1.9213 1.1092v-2.2159l1.9213-1.1092L16.532 6.0944l-1.9213 1.1092zm0 4.4442l1.9213-1.1092 1.9213 1.1092v2.2159l-1.9213 1.1092-1.9213-1.1092V8.9584zm-2.6107 4.8566l-1.9213-1.1093v-2.2159l1.9213 1.1093 1.9213-1.1093v2.2159l-1.9213 1.1093z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenai);
export default __webpack_public_path__ + "static/media/openai.4295ab9eb3613e69b61cb49aefd3ea77.svg";
export { ForwardRef as ReactComponent };